import { render, staticRenderFns } from "./Flavor.vue?vue&type=template&id=04fc7155&scoped=true"
import script from "./Flavor.vue?vue&type=script&lang=js"
export * from "./Flavor.vue?vue&type=script&lang=js"
import style0 from "./Flavor.vue?vue&type=style&index=0&id=04fc7155&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fc7155",
  null
  
)

export default component.exports